import { Box, AppBar, Toolbar, Typography, IconButton } from "@mui/material";
import React from "react";
import { ReactComponent as PrintSvg } from "../../../components/icon/printicon.svg";
import { ReactComponent as ShareIcon } from "../../../components/icon/shareicon.svg";
import { capitalizeAllLetter } from "../common-component/CapitalizeFirstLetter";

function Header2(props: any) {
  console.log(props);
  console.log("View type in header2:", props.viewType);
  console.log("Widget Data:", props.widgetData.id);

  const handlePrint = () => {
    console.log("Entered handlePrint in header component");

    props.parentCallback({ print: true, viewType: props.viewType });
  };
  const handleExport = () => {
    props.exportCallback({
      export: true,
      widgetId: props.widgetData.id,
    });
  };
  return (
    <Box sx={{ flexGrow: 1, marginBottom: 2 }}>
      <AppBar
        position="static"
        sx={{
          bgcolor: "#0FA3B1",
          height: "27px",
          borderTopLeftRadius: 6,
          borderTopRightRadius: 6,
        }}
      >
        <Toolbar>
          <Typography
            component="div"
            sx={{ flexGrow: 1, marginTop: "-35px", marginLeft: "-9px" }}
          >
            {capitalizeAllLetter(props.name)}
          </Typography>
          <IconButton>
            <PrintSvg
              onClick={handlePrint}
              fontSize="small"
              //   style={{
              //     width: 17,
              //     height: 17,
              //     margin: 0,
              //     marginLeft: 7,
              //     marginTop: "-35px",
              //     color: "white",
              //   }}
              style={{
                width: 17,
                height: 17,
                margin: 0,
                marginLeft: 7,
                marginTop: "-35px",
                color: "white",
                display: props.viewType !== "Grid" ? "block" : "none",
              }}
            />
          </IconButton>
          {/* <button>
                        <Refresh fontSize="small" style={{ margin: 0, marginLeft:7,marginTop: '-20px', color:'white' }}/>
                    </button> */}
          <IconButton
            style={{
              display: props.viewType === "Grid" ? "block" : "none",
            }}
          >
            <ShareIcon
              fontSize="small"
              style={{
                width: 17,
                height: 17,
                margin: 0,
                marginLeft: 7,
                marginTop: "-35px",
                color: "white",
              }}
              onClick={handleExport}
            />
          </IconButton>

          {/* <button>
						<MinimizeIcon fontSize="small" style={{ margin: 0,marginLeft:7, marginTop: '-0px', color:'white' }} />
                        </button>
						<button><ArrowsOut fontSize="small" style={{ margin: 0,marginLeft:7, marginTop: '-20px', color:'white' }} /></button>
					 */}
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default Header2;
